<script>
import { Cell, Row, Col, Image, Tabs, Tab, List, Empty, SwipeCell, Button, Dialog } from 'vant'
import BottomToolbar from '@/components/org/BottomToolbar'
import ObjectFunc from '@/tbs/util/ObjectFunc'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-team-manage',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-image': Image,
        'van-tabs': Tabs,
        'van-tab': Tab,
        'van-list': List,
        'van-empty': Empty,
        'van-swipe-cell': SwipeCell,
        'van-button': Button,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            teamManager: {
                team: {
                    id: null,
                    matchGroupId: null,
                    name: null,
                    logoUrl: null, 
                },
                playerList: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        isPlayerListEmtpy() {
            console.log('isPlayerListEmtpy', this.teamManager.playerList)
            return this.teamManager.playerList && ((this.teamManager.playerList.length == 0) || ObjectFunc.isEmpty(this.teamManager.playerList))
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onGoSpaceBtnClick() {
            console.log('onGoSpaceBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    url: 'banmabang://teamdetail?teamId=' + this.teamManager.team.id
                }
            })
        },
        onTeamInfoClick() {
            console.log('onTeamInfoBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditTeam',
                    params: {
                        id: this.teamManager.team.id
                    },
                    query: {
                        matchGroupId: this.teamManager.team.matchGroupId,
                        matchId: this.teamManager.team.matchId
                    }
                }
            })
        },
        onPlayerItemClick(item) {
            console.log('onPlayerItemClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailPlayer',
                    params: {
                        id: item.id
                    },
                    query: {
                        matchGroupId: this.teamManager.team.matchGroupId,
                        matchId: this.teamManager.team.matchId,
                        teamId: this.teamManager.team.id
                    }
                }
            })
        },
        onPlayerDeleteBtnClick(item) {
            console.log('onPlayerItemClick', item)
            Dialog.confirm({
                title: this.locale['delete-player'],
                message: this.locale['delete-player-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete',
                    data: { id: item.id, matchGroupId: this.teamManager.team.matchGroupId }
                })
            }).catch(() => {
                // on cancel
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreatePlayer',
                    query: {
                        teamId: this.teamManager.team.id,
                        matchGroupId: this.teamManager.team.matchGroupId
                    }
                }
            })
        },
        onBatchBtnClick() {
            console.log('onBatchBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgBatchPlayer',
                    query: {
                        teamId: this.teamManager.team.id,
                        matchGroupId: this.teamManager.team.matchGroupId
                    }
                }
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="org-team-manage">
        <div class="team-summary-wrapper">
            <van-cell class="team-summary">
                <van-row>
                    <van-col 
                        span="6"
                        class="vertical-center logo-wrapper">
                        <van-image
                            v-if="teamManager.team.logoUrl"
                            :src="adjustImageSize(teamManager.team.logoUrl, 120, 120)"
                            center
                            fit="cover" 
                            width="60px" 
                            height="60px"
                        />
                        <img
                            v-else
                            src="@/assets/org/logo-symbol.png" 
                            style="width: 60px; height: 60px;"
                        />
                    </van-col>
                    <van-col span="12" class="l-outer-margin t-inner-margin">
                        <div class="b-inner-margin text-left">
                            <span class="main-text van-ellipsis block">{{ teamManager.team.name }}</span>
                        </div>
                    </van-col>
                    <van-col span="6">
                        <van-cell
                            class="no-padding basic-info"
                            :title="locale['basic-info']"
                            is-link center
                            @click="onTeamInfoClick"
                        />
                        <div class="space-link">
                            <div class="link-wrapper justify-center vertical-center" @click="onGoSpaceBtnClick">
                                <span class="link-label primary-color">{{ locale['team-space'] }}</span>
                            </div>
                        </div>
                    </van-col>
                </van-row>
            </van-cell>
        </div>
        <van-tabs sticky
            offset-top="43">
            <van-tab :title="locale['player']">
                <div v-if="!isPlayerListEmtpy">
                    <van-list>
                        <van-swipe-cell 
                            v-for="item in teamManager.playerList" 
                            :key="item.id"
                        >
                            <van-cell 
                                center
                                is-link
                                @click="onPlayerItemClick(item)"
                            >
                                <template #title>
                                    <div>
                                        <van-row>
                                            <van-col>
                                                <van-image
                                                    v-if="item.logoUrl"
                                                    :src="adjustImageSize(item.logoUrl, 120, 120)"
                                                    fit="cover"
                                                    width="60px"
                                                    height="60px"
                                                />
                                                <img
                                                    v-else
                                                    src="@/assets/org/logo-symbol.png" 
                                                    style="width: 60px; height: 60px;"
                                                />
                                            </van-col>
                                            <van-col class="u-inner-margin">
                                                <div>
                                                    <span class="r-inner-margin">{{ item.num }}</span>
                                                    <span>{{ item.name }}</span>
                                                </div>
                                            </van-col>
                                        </van-row>
                                    </div>
                                </template>
                            </van-cell>
                            <template #right>
                                <van-button 
                                    class="delete-btn"
                                    square 
                                    type="danger" 
                                    :text="locale['delete']"
                                    @click="onPlayerDeleteBtnClick(item)"
                                />
                            </template>
                        </van-swipe-cell>
                    </van-list>
                </div>
                <div v-else @click="onCreateBtnClick">
                    <van-empty 
                        :description="locale['player-empty-hint']"
                        image="search"
                    />
                </div>
            </van-tab>
        </van-tabs>
        <bottom-toolbar 
            type="button-button" 
            :mainButtonLabel="locale['create']"
            :minorButtonLabel="locale['batch-create']"
            @click-main-button="onCreateBtnClick"
            @click-minor-button="onBatchBtnClick"
        />
    </div>
</template>

<style scoped>
.team-summary-wrapper {
    margin: 10px;
}
.logo-wrapper {
    padding: 4px;
    border-radius: 4px;
    border: 1px solid #DCDEE0;
    width: 70px;
    height: 70px;
}
.basic-info span,
.basic-info i {
    font-size: 13px;
    color: #323233;
}
.space-link {
    margin-top: 20px;
    margin-left: 8px;
    margin-bottom: 6px;
}
.link-wrapper {
    width: 70px;
    height: 22px;
    border-radius: 50px;
    background: rgba(74, 162, 247, .2)
}
.link-label {
    font-size: 12px;
}
.delete-btn {
    height: 89px;
    width: 80px;
}
</style>